import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AuthenticationStrengthPolicy } from '@microsoft/microsoft-graph-types-beta';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'authenticationStrengthPolicies';

export interface State extends EntityState<AuthenticationStrengthPolicy>, Status {}

export const adapter: EntityAdapter<AuthenticationStrengthPolicy> = createEntityAdapter<AuthenticationStrengthPolicy>();

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    // load

    on(actions.loadAuthenticationStrengthPoliciesSuccess, (state, action) =>
        adapter.upsertMany(action.polices, { ...state, loaded: true, error: null }),
    ),
    on(actions.loadAuthenticationStrengthPoliciesFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
